module.exports = __webpack_public_path__ + "img/4.d26b9057.png";